import React from "react";
import { marqueeText } from "../mock";

const Marquee = () => {
  const repeated = Array(8).fill(marqueeText);
  return (
    <section id="about" className="bg-[#d8d6d0] py-8 md:py-12 overflow-hidden border-y border-neutral-300/60">
      <div className="marquee">
        {[...repeated, ...repeated].map((t, i) => (
          <span
            key={`${t}-${i}`}
            className="marquee-item font-display text-neutral-900 text-5xl md:text-7xl lg:text-8xl"
            style={{ fontWeight: 700 }}
          >
            {t}
            <span className="text-neutral-400 mx-6">&middot;</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
